<!-- loader.component.html -->
<div *ngIf="showLoader" class="loader">
  <div class="loading-wrap">
    <div class="loading">
      <div class="bounceball"></div>
      <div class="text">Please wait it's loading...</div>
    </div>
  </div>
</div>